import { Routes } from '@angular/router';

export const PROJECT_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./project-list.component').then(m => m.ProjectListComponent),
    title: 'Projects'
  },
  {
    path: 'new',
    loadComponent: () => import('./add-project/add-project.component').then(m => m.AddProjectComponent),
    title: 'New Project'
  },
  {
    path: 'new/:id',
    loadComponent: () => import('./project-info-component/project-info-component.component').then(m => m.ProjectInfoComponentComponent),
    title: 'New Project'
  },
  {
    path: 'milestone-list',
    loadComponent: () => import('./milestones-component/milestones-list/milestones-list.component').then(m => m.MilestonesListComponent),
    title: 'Milestonet'
  },
  {
    path: 'milestone/:id',
    loadComponent: () => import('./milestones-component/milestones-component.component').then(m => m.MilestonesComponentComponent),
    title: 'Milestonet'
  },
  {
    path: 'milestone',
    loadComponent: () => import('./milestones-component/milestones-component.component').then(m => m.MilestonesComponentComponent),
    title: 'Milestonet'
  },
  {
    path: 'finance-policy/:id',
    loadComponent: () => import('./finance-policy-component/finance-policy-component.component').then(m => m.FinancePolicyComponentComponent),
    title: 'Milestonet'
  },
  {
    path: 'finance-policy',
    loadComponent: () => import('./finance-policy-component/finance-policy-component.component').then(m => m.FinancePolicyComponentComponent),
    title: 'Milestonet'
  },
  {
    path: 'finance-policy-list',
    loadComponent: () => import('./finance-policy-component/finance-policy-list/finance-policy-list.component').then(m => m.FinancePolicyListComponent),
    title: 'Milestonet'
  },
  {
    path: 'delay-windows/:id',
    loadComponent: () => import('./delay-windows-component/delay-windows-component.component').then(m => m.DelayWindowsComponentComponent),
    title: 'Milestonet'
  },
  {
    path: 'delay-windows',
    loadComponent: () => import('./delay-windows-component/delay-windows-component.component').then(m => m.DelayWindowsComponentComponent),
    title: 'Milestonet'
  },
  {
    path: 'delay-windows-list',
    loadComponent: () => import('./delay-windows-component/delay-windows-list/delay-windows-list.component').then(m => m.DelayWindowsListComponent),
    title: 'Milestonet'
  },
  {
    path: 'add-unit/:id',
    loadComponent: () => import('./add-unit/add-unit.component').then(m => m.AddUnitComponent),
    title: 'Milestonet'
  },
  {
    path: 'add-unit',
    loadComponent: () => import('./add-unit/add-unit.component').then(m => m.AddUnitComponent),
    title: 'Milestonet'
  },
  {
    path: 'units-list',
    loadComponent: () => import('./add-unit/units-list/units-list.component').then(m => m.UnitsListComponent),
    title: 'Milestonet'
  },
  {
    path: 'template',
    loadComponent: () => import('./communication-template/communication-template.component').then(m => m.CommunicationTemplateComponent),
    title: 'Template'
  },
  {
    path: 'journey-action',
    loadComponent: () => import('./journey-action/journey-action.component').then(m => m.JourneyActionComponent),
    title: 'journey-action'
  },
  {
    path: 'create-booking',
    loadComponent: () => import('./create-booking/create-booking.component').then(m => m.CreateBookingComponent),
    title: 'create-booking'
  },
  {
    path: 'create-booking/:id',
    loadComponent: () => import('./create-booking/booking-details/booking-details.component').then(m => m.BookingDetailsComponent),
    title: 'create-booking'
  },
  {
    path: 'booking-dashboard/:id',
    loadComponent: () => import('./create-booking/booking-dashboard/booking-dashboard.component').then(m => m.BookingDashboardComponent),
    title: 'booking-dashboard'
  },
  {
    path: 'booking-milestone/:id',
    loadComponent: () => import('./create-booking/booking-milestones/booking-milestones.component').then(m => m.BookingMilestonesComponent),
    title: 'create-booking'
  },
  {
    path: 'booking-list',
    loadComponent: () => import('./booking-list/booking-list.component').then(m => m.BookingListComponent),
    title: 'booking-list'
  },
  {
    path: 'project-progress',
    loadComponent: () => import('./project-progress/project-progress.component').then(m => m.ProjectProgressComponent),
    title: 'project-progress'
  },
  {
    path: 'brokers',
    loadComponent: () => import('./broker-list/broker-list.component').then(m => m.BrokerListComponent),
    title: 'Broker'
  },
  {
    path: 'broker/create',
    loadComponent: () => import('./broker-list/create-broker/create-broker.component').then(m => m.CreateBrokerComponent),
    title: 'Create-Broker'
  },
  {
    path: 'broker/create/:id',
    loadComponent: () => import('./broker-list/create-broker/create-broker.component').then(m => m.CreateBrokerComponent),
    title: 'Edit-Broker'
  },
  {
    path: 'waiver',
    loadComponent: () => import('../../shared/waiver/waiver').then(m => m.WaiverComponent),
    title: 'Create-waiver'
  },
  {
    path: 'waiver/:id',
    loadComponent: () => import('../../shared/waiver/waiver').then(m => m.WaiverComponent),
    title: 'Edit-waiver'
  },
  {
    path: 'waiver-list',
    loadComponent: () => import('./booking-list/waiver-list/waiver-list.component').then(m => m.WaiverListComponent),
    title: 'waivers'
  },
  {
    path: 'payment',
    loadComponent: () => import('./booking-list/payments/payments.component').then(m => m.PaymentsComponent),
    title: 'Create-Payment'
  },
  {
    path: 'payment/:id',
    loadComponent: () => import('./booking-list/payments/payments.component').then(m => m.PaymentsComponent),
    title: 'Edit-Payment'
  },
  {
    path: 'payment-list',
    loadComponent: () => import('./booking-list/payments/payments-list/payments-list.component').then(m => m.PaymentsListComponent),
    title: 'Payments'
  },
  {
    path: 'document',
    loadComponent: () => import('./booking-list/document/document.component').then(m => m.DocumentComponent),
    title: 'Create-Document'
  },
  {
    path: 'document/:id',
    loadComponent: () => import('./booking-list/document/document.component').then(m => m.DocumentComponent),
    title: 'Edit-Document'
  },
  {
    path: 'document-list',
    loadComponent: () => import('./booking-list/document/documents-list/documents-list.component').then(m => m.DocumentListComponent),
    title: 'Documents'
  },
];
